import React, { FC }    from "react";
import { Button, Icon } from "semantic-ui-react";

interface Props {
  onClick: () => void;
  label: string;
}

const AddButton: FC<Props> = (props: Props) => (
  <>
    <Button
      icon
      labelPosition="left"
      onClick={ () => props.onClick() }
    >
      <Icon name="plus"/>
      { props.label }
    </Button>
  </>
);

export default AddButton;